export const sortCurrencyOptions = (options: { value: string; label: string }[]) => {
  const priorityCurrencies = ["BRL", "USD", "EUR"];
  const priorityOptions = priorityCurrencies
    .map((code) => options.find((opt) => opt.value === code))
    .filter(Boolean) as { value: string; label: string }[];

  const otherOptions = options
    .filter((opt) => !priorityCurrencies.includes(opt.value))
    .sort((a, b) => a.label.localeCompare(b.label));

  return [...priorityOptions, ...otherOptions];
};
